<template>

<com-logic>

    <com-operand :type="type" :rule="rule" :options="options" v-model="model.operand" />

    <com-input :type="type" :rule="rule" v-model="model.value" />

</com-logic>

</template>

<script>

import mixLogic from './logic'

export default {

    mixins: [mixLogic],

    data: function() {
        
        return {
            model: {
                operand: '=',
                value: ''
            },
            options: [
                '=',
                '!='
            ]
        }
        
    }

}

</script>

<style scoped>

</style>